import { useState, useRef, useCallback, useEffect } from "react";
import axios from 'axios';
import configs from '../config/config';
import NavigationBar from '../components/NavigationBar';

// ─── SVG Icons (for editor UI only) ──────────────────────────────────────────
const Icon = ({ name, size = 18, color = "currentColor" }) => {
  const a = { fill: "none", stroke: color, strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" };
  const d = {
    menu:     <><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></>,
    plus:     <><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></>,
    trash:    <><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14H6L5 6"/><path d="M10 11v6M14 11v6"/><path d="M9 6V4h6v2"/></>,
    eye:      <><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></>,
    eyeoff:   <><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/><path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/><line x1="1" y1="1" x2="23" y2="23"/></>,
    image:    <><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></>,
    type:     <><polyline points="4 7 4 4 20 4 20 7"/><line x1="9" y1="20" x2="15" y2="20"/><line x1="12" y1="4" x2="12" y2="20"/></>,
    palette:  <><circle cx="13.5" cy="6.5" r=".5" fill={color}/><circle cx="17.5" cy="10.5" r=".5" fill={color}/><circle cx="8.5" cy="7.5" r=".5" fill={color}/><circle cx="6.5" cy="12.5" r=".5" fill={color}/><path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c.926 0 1.648-.746 1.648-1.688 0-.437-.18-.835-.437-1.125-.29-.289-.438-.652-.438-1.125a1.64 1.64 0 0 1 1.668-1.668h1.996c3.051 0 5.555-2.503 5.555-5.554C21.965 6.012 17.461 2 12 2z"/></>,
    search:   <><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></>,
    check:    <polyline points="20 6 9 20 4 15"/>,
    x:        <><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></>,
    layout:   <><rect x="3" y="3" width="18" height="18" rx="2"/><line x1="3" y1="9" x2="21" y2="9"/><line x1="9" y1="21" x2="9" y2="9"/></>,
    star:     <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>,
    save:     <><path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/><polyline points="17 21 17 13 7 13 7 21"/><polyline points="7 3 7 8 15 8"/></>,
    settings: <><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/></>,
    bag:      <><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></>,
    user:     <><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></>,
    undo:     <><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 .49-3.39"/></>,
    link:     <><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/></>,
    chevdown: <polyline points="6 9 12 15 18 9"/>,
    chevup:   <polyline points="18 15 12 9 6 15"/>,
    alert:    <><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></>,
    loader:   <><line x1="12" y1="2" x2="12" y2="6"/><line x1="12" y1="18" x2="12" y2="22"/><line x1="4.93" y1="4.93" x2="7.76" y2="7.76"/><line x1="16.24" y1="16.24" x2="19.07" y2="19.07"/><line x1="2" y1="12" x2="6" y2="12"/><line x1="18" y1="12" x2="22" y2="12"/><line x1="4.93" y1="19.07" x2="7.76" y2="16.24"/><line x1="16.24" y1="7.76" x2="19.07" y2="4.93"/></>,
  };
  return <svg width={size} height={size} viewBox="0 0 24 24" {...a}>{d[name]}</svg>;
};

// ─── Helpers ──────────────────────────────────────────────────────────────────
const uid = () => Math.random().toString(36).slice(2, 8);

// ─── Default state ────────────────────────────────────────────────────────────
const DEFAULTS = {
  topBar: {
    visible: true,
    gradient: ["#2563eb", "#1d4ed8"],
    leftMain: "Free shipping on orders over $50",
    leftSub: "Mon–Fri, 9am–6pm",
    currencies: ["USD $", "EUR €", "GBP £", "KES KSh"],
  },
  logo: { 
    type: "text", 
    text: "ShopBrand", 
    fontSize: 24, 
    fontWeight: "700", 
    color: "#111827", 
    imageUrl: "", 
    width: 180, 
    height: 50 
  },
  search: { 
    visible: true, 
    placeholder: "Search products…", 
    borderColor: "#d1d5db", 
    borderRadius: 8, 
    focusColor: "#2563eb", 
    bgColor: "#f3f4f6", 
    iconColor: "#6b7280", 
    width: "300px" 
  },
  menuItems: [
    { id: uid(), label: "Home",    href: "/",        position: "left",  bold: false },
    { id: uid(), label: "Shop",    href: "/shop",    position: "left",  bold: false },
    { id: uid(), label: "About",   href: "/about",   position: "left",  bold: false },
    { id: uid(), label: "Contact", href: "/contact", position: "right", bold: false },
  ],
  nav: { 
    bg: "#ffffff", 
    shadow: true, 
    sticky: true, 
    height: 70, 
    borderBottom: true, 
    borderColor: "#e5e7eb" 
  },
  icons: { color: "#111827", size: 26 },
  cartBadgeColor: "#2563eb",
  menuFontSize: 15,
  menuTextColor: "#111827",
  menuPosition: "left",
};

// ─── Style tokens ─────────────────────────────────────────────────────────────
const T = {
  indigo:   "#6366f1",
  indigoBg: "#eef2ff",
  label: { display:"block", fontSize:10, fontWeight:700, color:"#94a3b8", textTransform:"uppercase", letterSpacing:"0.08em", marginBottom:6 },
  input: { width:"100%", border:"1.5px solid #e2e8f0", borderRadius:10, padding:"10px 12px", fontSize:14, color:"#1e293b", background:"#fff", outline:"none", boxSizing:"border-box", fontFamily:"inherit" },
  card:  { background:"#f8fafc", borderRadius:12, border:"1.5px solid #f1f5f9", padding:"14px", marginBottom:14 },
};

// ─── Primitive components ─────────────────────────────────────────────────────
const Field = ({ label, hint, children }) => (
  <div style={{ marginBottom:20 }}>
    <label style={T.label}>{label}</label>
    {hint && <p style={{ fontSize:11, color:"#94a3b8", marginBottom:6 }}>{hint}</p>}
    {children}
  </div>
);

const Inp = ({ extraStyle, ...props }) => (
  <input style={{ ...T.input, ...extraStyle }} {...props} />
);

const Sel = ({ children, ...props }) => (
  <select style={{ ...T.input, cursor:"pointer" }} {...props}>{children}</select>
);

const Toggle = ({ value, onChange, label }) => (
  <label style={{ display:"flex", alignItems:"center", gap:12, cursor:"pointer", userSelect:"none" }}>
    <div onClick={() => onChange(!value)} style={{ position:"relative", width:44, height:24, borderRadius:99, background:value ? T.indigo:"#e2e8f0", transition:"background .2s", cursor:"pointer", flexShrink:0 }}>
      <span style={{ position:"absolute", top:3, left:3, width:18, height:18, background:"#fff", borderRadius:"50%", boxShadow:"0 1px 4px rgba(0,0,0,.2)", transition:"transform .2s", transform:value ? "translateX(20px)":"none" }} />
    </div>
    {label && <span style={{ fontSize:14, color:"#475569" }}>{label}</span>}
  </label>
);

const ColorPicker = ({ label, value, onChange }) => (
  <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:14 }}>
    <span style={{ fontSize:14, color:"#475569" }}>{label}</span>
    <div style={{ display:"flex", alignItems:"center", gap:8 }}>
      <span style={{ fontSize:11, color:"#94a3b8", fontFamily:"monospace" }}>{value}</span>
      <label style={{ cursor:"pointer", position:"relative" }}>
        <div style={{ width:32, height:32, borderRadius:9, border:"2.5px solid #fff", boxShadow:"0 1px 6px rgba(0,0,0,.18)", background:value, cursor:"pointer" }} />
        <input type="color" value={value} onChange={e => onChange(e.target.value)} style={{ position:"absolute", opacity:0, width:0, height:0, pointerEvents:"none" }} />
      </label>
    </div>
  </div>
);

const Slider = ({ label, value, min, max, onChange }) => (
  <div style={{ marginBottom:20 }}>
    <div style={{ display:"flex", justifyContent:"space-between", marginBottom:6 }}>
      <label style={T.label}>{label}</label>
      <span style={{ fontSize:12, color:T.indigo, fontWeight:700 }}>{value}px</span>
    </div>
    <input type="range" min={min} max={max} value={value} onChange={e => onChange(+e.target.value)} style={{ width:"100%", accentColor:T.indigo }} />
  </div>
);

const GradientPicker = ({ colors, onChange }) => (
  <div>
    <div style={{ height:36, borderRadius:10, marginBottom:10, background:`linear-gradient(to right,${colors[0]},${colors[1]})`, boxShadow:"inset 0 1px 3px rgba(0,0,0,.1)" }} />
    <div style={{ display:"flex", gap:12 }}>
      {colors.map((c,i) => (
        <label key={i} style={{ flex:1, cursor:"pointer" }}>
          <div style={{ height:40, borderRadius:9, border:"2px solid #fff", boxShadow:"0 1px 6px rgba(0,0,0,.14)", background:c }} />
          <input type="color" value={c} onChange={e => { const n=[...colors]; n[i]=e.target.value; onChange(n); }} style={{ position:"absolute", opacity:0, width:0, height:0 }} />
          <p style={{ textAlign:"center", fontSize:10, color:"#94a3b8", marginTop:4, fontFamily:"monospace" }}>{c}</p>
        </label>
      ))}
    </div>
  </div>
);

const SectionHead = ({ emoji, title, sub }) => (
  <div style={{ marginBottom:22 }}>
    <div style={{ fontSize:26, marginBottom:4, lineHeight:1 }}>{emoji}</div>
    <h2 style={{ fontSize:17, fontWeight:800, color:"#0f172a", margin:0, letterSpacing:"-0.3px" }}>{title}</h2>
    {sub && <p style={{ fontSize:12, color:"#94a3b8", margin:"4px 0 0" }}>{sub}</p>}
  </div>
);

const Divider = () => <div style={{ height:1, background:"#f1f5f9", margin:"18px 0" }} />;

const PillBtn = ({ active, onClick, children }) => (
  <button onClick={onClick} style={{ flex:1, padding:"10px 8px", borderRadius:10, cursor:"pointer", border:active ? `2px solid ${T.indigo}`:"1.5px solid #e2e8f0", background:active ? T.indigoBg:"#fff", color:active ? T.indigo:"#64748b", fontWeight:700, fontSize:13 }}>
    {children}
  </button>
);

// ─── Panels ──────────────────────────────────────────────────────────────────
const TopBarPanel = ({ cfg, set }) => {
  const [newCur, setNewCur] = useState("");
  const tb = cfg.topBar;
  const upd = patch => set("topBar", { ...tb, ...patch });
  const addCur = () => { if (!newCur.trim()) return; upd({ currencies:[...tb.currencies, newCur.trim()] }); setNewCur(""); };

  return (
    <div>
      <SectionHead emoji="📣" title="Top Info Bar" sub="Announcement strip above the navbar" />
      <div style={T.card}><Toggle value={tb.visible} onChange={v => upd({ visible:v })} label="Show top bar" /></div>
      {tb.visible && <>
        <Field label="Main message"><Inp value={tb.leftMain} onChange={e => upd({ leftMain:e.target.value })} /></Field>
        <Field label="Sub message (desktop)"><Inp value={tb.leftSub} onChange={e => upd({ leftSub:e.target.value })} /></Field>
        <Field label="Background gradient"><GradientPicker colors={tb.gradient} onChange={g => upd({ gradient:g })} /></Field>
        <Divider />
        <Field label="Currency options" hint="Edit or add currency options">
          <div style={{ display:"flex", flexDirection:"column", gap:8, marginBottom:10 }}>
            {tb.currencies.map((c,i) => (
              <div key={i} style={{ display:"flex", gap:8 }}>
                <Inp value={c} onChange={e => { const a=[...tb.currencies]; a[i]=e.target.value; upd({ currencies:a }); }} extraStyle={{ flex:1 }} />
                <button onClick={() => upd({ currencies:tb.currencies.filter((_,j) => j!==i) })} style={{ padding:"8px 10px", borderRadius:9, border:"none", background:"#fef2f2", color:"#ef4444", cursor:"pointer", flexShrink:0 }}>
                  <Icon name="x" size={14} color="#ef4444" />
                </button>
              </div>
            ))}
          </div>
          <div style={{ display:"flex", gap:8 }}>
            <Inp value={newCur} onChange={e => setNewCur(e.target.value)} placeholder="e.g. JPY ¥" extraStyle={{ flex:1 }} onKeyDown={e => e.key==="Enter" && addCur()} />
            <button onClick={addCur} style={{ padding:"10px 16px", borderRadius:9, border:"none", background:T.indigo, color:"#fff", fontWeight:700, fontSize:13, cursor:"pointer", flexShrink:0 }}>+ Add</button>
          </div>
        </Field>
      </>}
    </div>
  );
};

const LogoPanel = ({ cfg, set }) => {
  const fileRef = useRef();
  const logo = cfg.logo;
  const upd  = patch => set("logo", { ...logo, ...patch });
  const handleFile = e => {
    const f = e.target.files[0]; if (!f) return;
    const r = new FileReader();
    r.onload = ev => upd({ type:"image", imageUrl:ev.target.result });
    r.readAsDataURL(f);
  };

  return (
    <div>
      <SectionHead emoji="🏷️" title="Logo" sub="Brand mark at the start of the navbar" />
      <Field label="Logo type">
        <div style={{ display:"flex", gap:8 }}>
          <PillBtn active={logo.type==="text"}  onClick={() => upd({ type:"text" })}>✏️ Text</PillBtn>
          <PillBtn active={logo.type==="image"} onClick={() => upd({ type:"image" })}>🖼 Image</PillBtn>
        </div>
      </Field>
      {logo.type === "text" ? <>
        <Field label="Logo text"><Inp value={logo.text} onChange={e => upd({ text:e.target.value })} /></Field>
        <Slider label="Font size" value={logo.fontSize} min={14} max={52} onChange={v => upd({ fontSize:v })} />
        <Field label="Font weight">
          <div style={{ display:"flex", gap:6, flexWrap:"wrap" }}>
            {["400","500","600","700","800","900"].map(w => (
              <button key={w} onClick={() => upd({ fontWeight:w })} style={{ padding:"6px 12px", borderRadius:6, fontWeight:w, border:logo.fontWeight===w ? `2px solid ${T.indigo}`:"1px solid #e2e8f0", background:logo.fontWeight===w ? T.indigoBg:"#fff" }}>
                {w}
              </button>
            ))}
          </div>
        </Field>
        <ColorPicker label="Text color" value={logo.color} onChange={c => upd({ color:c })} />
      </> : <>
        <Field label="Upload logo" hint="PNG, SVG, JPG — transparent recommended">
          <div onClick={() => fileRef.current.click()} style={{ border:"2px dashed #c7d2fe", borderRadius:12, padding:"32px 20px", textAlign:"center", cursor:"pointer", background:"#fafbff" }}>
            <div style={{ fontSize:32, marginBottom:8 }}>🖼</div>
            <p style={{ fontSize:13, color:T.indigo, fontWeight:600, margin:0 }}>Click to upload logo</p>
            <p style={{ fontSize:11, color:"#94a3b8", margin:"4px 0 0" }}>max 2MB</p>
          </div>
          <input ref={fileRef} type="file" accept="image/*" style={{ display:"none" }} onChange={handleFile} />
        </Field>
        {logo.imageUrl && (
          <div style={{ display:"flex", alignItems:"center", gap:12, padding:"12px 14px", background:"#f8fafc", borderRadius:12, border:"1.5px solid #e2e8f0", marginBottom:16 }}>
            <img 
              src={logo.imageUrl} 
              alt="logo" 
              style={{ 
                width: logo.width || 180, 
                height: logo.height || 50, 
                objectFit: "contain" 
              }} 
            />
            <span style={{ flex:1, fontSize:13, color:"#475569" }}>Uploaded (data URL)</span>
            <button onClick={() => upd({ imageUrl:"", type:"text" })} style={{ padding:"6px 12px", borderRadius:8, background:"#fef2f2", color:"#ef4444", border:"none", cursor:"pointer" }}>Remove</button>
          </div>
        )}
        <Slider label="Logo width (px)" value={logo.width || 180} min={60} max={600} onChange={v => upd({ width: v })} />
        <Slider label="Logo height (px)" value={logo.height || 50} min={20} max={200} onChange={v => upd({ height: v })} />
      </>}
    </div>
  );
};

const SearchPanel = ({ cfg, set }) => {
  const s = cfg.search;
  const upd = patch => set("search", { ...s, ...patch });

  return (
    <div>
      <SectionHead emoji="🔍" title="Search Bar" sub="Customize search input" />
      <div style={T.card}><Toggle value={s.visible} onChange={v => upd({ visible:v })} label="Show search bar" /></div>
      {s.visible && <>
        <Field label="Placeholder text"><Inp value={s.placeholder} onChange={e => upd({ placeholder:e.target.value })} /></Field>
        <Slider label="Search bar width (px)" value={parseInt(s.width) || 300} min={180} max={600} onChange={v => upd({ width:`${v}px` })} />
        <Slider label="Border radius" value={s.borderRadius} min={0} max={30} onChange={v => upd({ borderRadius:v })} />
        <Divider />
        <ColorPicker label="Background color" value={s.bgColor} onChange={c => upd({ bgColor:c })} />
        <ColorPicker label="Border color" value={s.borderColor} onChange={c => upd({ borderColor:c })} />
        <ColorPicker label="Focus ring color" value={s.focusColor} onChange={c => upd({ focusColor:c })} />
        <ColorPicker label="Icon & text color" value={s.iconColor} onChange={c => upd({ iconColor:c })} />
      </>}
    </div>
  );
};

const MenuPanel = ({ cfg, set }) => {
  const [editing, setEditing] = useState(null);

  const addItem = () => {
    const item = { id:uid(), label:"New Link", href:"/", position:"left", bold:false };
    set("menuItems", [...cfg.menuItems, item]);
    setEditing(item.id);
  };
  const updItem = (id, patch) => set("menuItems", cfg.menuItems.map(m => m.id===id ? { ...m, ...patch } : m));
  const delItem = id => { set("menuItems", cfg.menuItems.filter(m => m.id!==id)); if (editing===id) setEditing(null); };
  const moveItem = (id, dir) => {
    const arr = [...cfg.menuItems];
    const i = arr.findIndex(m => m.id===id), j = i+dir;
    if (j < 0 || j >= arr.length) return;
    [arr[i], arr[j]] = [arr[j], arr[i]];
    set("menuItems", arr);
  };

  return (
    <div>
      <SectionHead emoji="🧭" title="Menu Items" sub="Add, reorder and configure links" />
      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:14 }}>
        <span style={{ fontSize:13, color:"#94a3b8" }}>{cfg.menuItems.length} item{cfg.menuItems.length!==1?"s":""}</span>
        <button onClick={addItem} style={{ display:"flex", alignItems:"center", gap:6, padding:"10px 16px", borderRadius:10, border:"none", background:T.indigo, color:"#fff", fontWeight:700, fontSize:13, cursor:"pointer", boxShadow:"0 2px 10px rgba(99,102,241,.3)" }}>
          <Icon name="plus" size={14} color="#fff" /> Add Link
        </button>
      </div>

      <div style={{ display:"flex", flexDirection:"column", gap:8 }}>
        {cfg.menuItems.map((item, i) => (
          <div key={item.id} style={{ border:editing===item.id ? `2px solid ${T.indigo}`:"1.5px solid #e2e8f0", borderRadius:12, overflow:"hidden", background:"#fff" }}>
            <div style={{ display:"flex", alignItems:"center", gap:8, padding:"12px" }}>
              <div style={{ display:"flex", flexDirection:"column", gap:2, flexShrink:0 }}>
                <button onClick={() => moveItem(item.id,-1)} disabled={i===0} style={{ border:"none", background:"none", color:i===0?"#e2e8f0":"#94a3b8", cursor:i===0?"default":"pointer", fontSize:11, padding:"1px 3px" }}>▲</button>
                <button onClick={() => moveItem(item.id,1)} disabled={i===cfg.menuItems.length-1} style={{ border:"none", background:"none", color:i===cfg.menuItems.length-1?"#e2e8f0":"#94a3b8", cursor:i===cfg.menuItems.length-1?"default":"pointer", fontSize:11, padding:"1px 3px" }}>▼</button>
              </div>
              <div style={{ flex:1, minWidth:0 }}>
                <div style={{ fontWeight:700, fontSize:14, color:"#1e293b", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{item.label}</div>
                <div style={{ fontSize:11, color:"#94a3b8", fontFamily:"monospace" }}>{item.href}</div>
              </div>
              <span style={{ fontSize:10, padding:"3px 8px", borderRadius:99, fontWeight:700, background:item.position==="left"?"#eff6ff":"#f5f3ff", color:item.position==="left"?"#3b82f6":"#7c3aed" }}>{item.position}</span>
              <button onClick={() => setEditing(editing===item.id ? null : item.id)} style={{ padding:"7px 8px", borderRadius:8, border:"none", cursor:"pointer", background:editing===item.id ? T.indigoBg:"#f8fafc", color:editing===item.id ? T.indigo:"#94a3b8" }}>
                <Icon name="settings" size={14} color={editing===item.id ? T.indigo:"#94a3b8"} />
              </button>
              <button onClick={() => delItem(item.id)} style={{ padding:"7px 8px", borderRadius:8, border:"none", background:"#fef2f2", color:"#ef4444", cursor:"pointer" }}>
                <Icon name="trash" size={14} color="#ef4444" />
              </button>
            </div>
            {editing === item.id && (
              <div style={{ padding:"12px 14px", borderTop:`1.5px solid ${T.indigoBg}`, background:"#fafbff" }}>
                <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:10, marginBottom:12 }}>
                  <div>
                    <label style={T.label}>Label</label>
                    <Inp value={item.label} onChange={e => updItem(item.id,{ label:e.target.value })} />
                  </div>
                  <div>
                    <label style={T.label}>URL / href</label>
                    <Inp value={item.href} onChange={e => updItem(item.id,{ href:e.target.value })} />
                  </div>
                </div>
                <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:10, alignItems:"end" }}>
                  <div>
                    <label style={T.label}>Position</label>
                    <Sel value={item.position} onChange={e => updItem(item.id,{ position:e.target.value })}>
                      <option value="left">Left</option>
                      <option value="right">Right</option>
                    </Sel>
                  </div>
                  <div>
                    <Toggle value={item.bold} onChange={v => updItem(item.id,{ bold:v })} label="Bold text" />
                  </div>
                </div>
              </div>
            )}
          </div>
        ))}
        {cfg.menuItems.length === 0 && (
          <div style={{ textAlign:"center", padding:"48px 0", color:"#cbd5e1" }}>
            <div style={{ fontSize:36, marginBottom:8 }}>🧭</div>
            <p style={{ fontSize:13, margin:0 }}>No menu items yet. Add one above.</p>
          </div>
        )}
      </div>
    </div>
  );
};

const StylePanel = ({ cfg, set }) => {
  const n = cfg.nav;
  const updNav = patch => set("nav", { ...n, ...patch });

  return (
    <div>
      <SectionHead emoji="🎨" title="Nav Style" sub="Background, height, shadow, icons" />
      <ColorPicker label="Nav background" value={n.bg} onChange={c => updNav({ bg:c })} />
      <Slider label="Nav height" value={n.height} min={48} max={100} onChange={v => updNav({ height:v })} />
      <div style={{ ...T.card, display:"flex", flexDirection:"column", gap:14 }}>
        <Toggle value={n.shadow} onChange={v => updNav({ shadow:v })} label="Drop shadow" />
        <Toggle value={n.sticky} onChange={v => updNav({ sticky:v })} label="Sticky on scroll" />
        <Toggle value={n.borderBottom} onChange={v => updNav({ borderBottom:v })} label="Bottom border" />
      </div>
      {n.borderBottom && <ColorPicker label="Border color" value={n.borderColor} onChange={c => updNav({ borderColor:c })} />}

      <Divider />

      <h3 style={{ margin:"16px 0 8px" }}>Menu Links</h3>
      <Slider label="Menu font size (px)" value={cfg.menuFontSize || 15} min={12} max={20} onChange={v => set("menuFontSize", v)} />
      <ColorPicker label="Menu text color" value={cfg.menuTextColor || "#111827"} onChange={c => set("menuTextColor", c)} />

      <Divider />

      <h3 style={{ margin:"16px 0 8px" }}>Icons & Cart</h3>
      <ColorPicker label="Icon color" value={cfg.icons.color} onChange={c => set("icons", { ...cfg.icons, color:c })} />
      <Slider label="Icon size (px)" value={cfg.icons.size} min={20} max={36} onChange={v => set("icons", { ...cfg.icons, size:v })} />
      <ColorPicker label="Cart badge color" value={cfg.cartBadgeColor} onChange={c => set("cartBadgeColor", c)} />
    </div>
  );
};

const SavePanel = ({ cfg }) => {
  const [apiUrl, setApiUrl] = useState(configs.API_URL + "/api/saveNavBarSettings/navbar");
  const [token, setToken] = useState(localStorage.getItem("token") || "");
  const [configKey, setConfigKey] = useState("navbar");
  const [status, setStatus] = useState(null);
  const [errorMsg, setErrorMsg] = useState("");
  const [lastSaved, setLastSaved] = useState(null);
  const [method, setMethod] = useState("POST");

  const save = async () => {
    if (!apiUrl.trim()) {
      setStatus("error");
      setErrorMsg("Please enter a valid API endpoint URL.");
      return;
    }

    setStatus("saving");
    setErrorMsg("");

    try {
      await axios.get(configs.API_URL + "/sanctum/csrf-cookie", { withCredentials: true });
      const xsrfToken = document.cookie.split('; ').find(row => row.startsWith('XSRF-TOKEN='))?.split('=')[1];

      const headers = {
        "Content-Type": "application/json",
        "Accept": "application/json",
      };
      if (token.trim()) headers["Authorization"] = `Bearer ${token.trim()}`;
      if (xsrfToken) headers["X-XSRF-TOKEN"] = decodeURIComponent(xsrfToken);

      const payload = {
        //key: configKey.trim() || "navbar",
        settings: cfg,
      };

      const res = await axios.post(apiUrl.trim(), payload, { headers, withCredentials: true });

      if (res.data.status === 1) {
        setStatus("success");
        setLastSaved(new Date().toLocaleTimeString([], { hour: '2-digit', minute:'2-digit' }));
        setTimeout(() => setStatus(null), 5000);
      } else {
        throw new Error(res.data.message || "Save failed");
      }
    } catch (err) {
      setStatus("error");
      setErrorMsg(err.message || "Failed to save");
    }
  };

  return (
    <div>
      <SectionHead title="Save Config" sub="Save to Laravel backend" />
     {/* <Field label="API Endpoint">
        <Inp value={apiUrl} onChange={e => setApiUrl(e.target.value)} />
      </Field>
      <Field label="Method">
        <div style={{ display:"flex", gap:8 }}>
          {["POST","PUT"].map(m => <PillBtn key={m} active={method===m} onClick={() => setMethod(m)}>{m}</PillBtn>)}
        </div>
      </Field>
      <Field label="Config Key">
        <Inp value={configKey} onChange={e => setConfigKey(e.target.value)} placeholder="navbar" />
      </Field>
      <Field label="Token (optional)">
        <Inp value={token} onChange={e => setToken(e.target.value)} extraStyle={{ fontFamily:"monospace" }} />
      </Field>*/}

      {status === "success" && <div style={{ padding:12, background:"#f0fdf4", border:"1px solid #bbf7d0", borderRadius:8, margin:16, color:"#15803d" }}>Saved at {lastSaved}</div>}
      {status === "error" && <div style={{ padding:12, background:"#fef2f2", border:"1px solid #fecaca", borderRadius:8, margin:16, color:"#b91c1c" }}>{errorMsg}</div>}

      <button onClick={save} disabled={status==="saving"} style={{ width:"100%", padding:14, background:status==="saving"?"#a5b4fc":"linear-gradient(135deg,#6366f1,#8b5cf6)", color:"#fff", border:"none", borderRadius:10, fontWeight:700, cursor:status==="saving"?"not-allowed":"pointer" }}>
        {status==="saving" ? "Saving..." : "Save Config"}
      </button>

     {/* <pre style={{ background:"#f8fafc", padding:12, borderRadius:8, fontSize:12, overflowX:"auto", marginTop:16 }}>
        {JSON.stringify(cfg, null, 2)}
      </pre>*/}
    </div>
  );
};

// ─── Root Component ───────────────────────────────────────────────────────────
export default function NavbarCMSEditor({ slug = '' }) {
  const [cfg, setCfg] = useState(DEFAULTS);
  const [activeTab, setActiveTab] = useState("topbar");
  const [showPreview, setShowPreview] = useState(false);
  const [previewMode, setPreviewMode] = useState("desktop");
  const [loading, setLoading] = useState(true);

  const token = localStorage.getItem("token");

  const set = useCallback((key, value) => setCfg(prev => ({ ...prev, [key]: value })), []);

  useEffect(() => {
    const loadNavigationSettings = async () => {
      if (!token) {
        setLoading(false);
        return;
      }

      setLoading(true);

      try {
        await axios.get(configs.API_URL + "/sanctum/csrf-cookie", { withCredentials: true });

        let response;
        const isDuplicate = slug && slug.includes('-');

        if (isDuplicate) {
          response = await axios.get(`${configs.API_URL}/api/pullCustomSettings/${slug}`, {
            headers: { Authorization: `Bearer ${token}` },
            withCredentials: true,
          });
        } else {
          response = await axios.get(configs.API_URL + '/api/pullNavBarSettings', {
            headers: { Authorization: `Bearer ${token}` },
            withCredentials: true,
          });
        }

        const dbData = isDuplicate
          ? (response.data.customSettings || {})
          : (response.data.navBarSettings || {});

        if (Object.keys(dbData).length > 0) {
          setCfg(prev => ({
            ...prev,
            topBar: {
              ...prev.topBar,
              visible: dbData.topBar?.visible ?? prev.topBar.visible,
              gradient: dbData.topBar?.gradient ?? prev.topBar.gradient,
              leftMain: dbData.topBar?.leftMain ?? dbData.topBarText ?? prev.topBar.leftMain,
              leftSub: dbData.topBar?.leftSub ?? dbData.topBarLeftText ?? prev.topBar.leftSub,
              currencies: dbData.topBar?.currencies ?? (dbData.currencyOptions ? dbData.currencyOptions.split(',') : prev.topBar.currencies),
            },
            logo: {
              ...prev.logo,
              type: dbData.logo?.type ?? (dbData.logoPath ? "image" : "text"),
              text: dbData.logo?.text ?? dbData.logo ?? prev.logo.text,
              fontSize: dbData.logo?.fontSize ?? prev.logo.fontSize,
              fontWeight: dbData.logo?.fontWeight ?? prev.logo.fontWeight,
              color: dbData.logo?.color ?? prev.logo.color,
              imageUrl: dbData.logo?.imageUrl || dbData.logoPath 
                ? dbData.logo?.imageUrl || `${configs.API_URL}${dbData.logoPath || dbData.logo?.imageUrl}`
                : prev.logo.imageUrl,
              width: dbData.logo?.width ?? prev.logo.width,
              height: dbData.logo?.height ?? prev.logo.height,
            },
            search: {
              ...prev.search,
              visible: dbData.search?.visible ?? true,
              placeholder: dbData.search?.placeholder ?? dbData.searchPlaceholder ?? prev.search.placeholder,
              borderColor: dbData.search?.borderColor ?? prev.search.borderColor,
              borderRadius: dbData.search?.borderRadius ?? prev.search.borderRadius,
              focusColor: dbData.search?.focusColor ?? prev.search.focusColor,
              bgColor: dbData.search?.bgColor ?? prev.search.bgColor,
              iconColor: dbData.search?.iconColor ?? prev.search.iconColor,
              width: dbData.search?.width ?? prev.search.width,
            },
            menuItems: dbData.menuItems?.map(item => ({
              id: item.id || uid(),
              label: item.label,
              href: item.href,
              position: item.position || "left",
              bold: item.bold ?? false,
            })) ?? prev.menuItems,
            nav: {
              ...prev.nav,
              bg: dbData.nav?.bg ?? dbData.customStyles?.backgroundColor ?? prev.nav.bg,
              shadow: dbData.nav?.shadow ?? true,
              sticky: dbData.nav?.sticky ?? true,
              height: dbData.nav?.height ?? 70,
              borderBottom: dbData.nav?.borderBottom ?? true,
              borderColor: dbData.nav?.borderColor ?? prev.nav.borderColor,
            },
            icons: {
              ...prev.icons,
              color: dbData.icons?.color ?? dbData.customStyles?.iconColor ?? prev.icons.color,
              size: dbData.icons?.size ?? 26,
            },
            cartBadgeColor: dbData.cartBadgeColor ?? dbData.customStyles?.cartBackgroundColor ?? prev.cartBadgeColor,
            menuFontSize: dbData.menuFontSize ?? 15,
            menuTextColor: dbData.menuTextColor ?? "#111827",
            menuPosition: dbData.menuPosition || "left",
          }));
        }
      } catch (error) {
        console.error("Failed to load navigation settings:", error);
      } finally {
        setLoading(false);
      }
    };

    loadNavigationSettings();
  }, [token, slug]);

  const tabs = [
    { id:"topbar", icon:"star",    label:"Top Bar" },
    { id:"logo",   icon:"type",    label:"Logo"    },
    { id:"search", icon:"search",  label:"Search"  },
    { id:"menu",   icon:"menu",    label:"Menu"    },
    { id:"style",  icon:"palette", label:"Style"   },
    { id:"save",   icon:"save",    label:"Save"    },
  ];

  const panels = {
    topbar: <TopBarPanel cfg={cfg} set={set} />,
    logo:   <LogoPanel   cfg={cfg} set={set} />,
    search: <SearchPanel cfg={cfg} set={set} />,
    menu:   <MenuPanel   cfg={cfg} set={set} />,
    style:  <StylePanel  cfg={cfg} set={set} />,
    save:   <SavePanel   cfg={cfg} />,
  };

  const tabBtnStyle = active => ({
    display:"flex",
    alignItems:"center",
    gap:6,
    padding:"8px 12px",
    borderRadius:10,
    fontSize:13,
    fontWeight:600,
    border:"none",
    cursor:"pointer",
    transition:"all .15s",
    background: active ? T.indigo : "transparent",
    color: active ? "#fff" : "#94a3b8",
    boxShadow: active ? "0 2px 10px rgba(99,102,241,.28)" : "none",
    whiteSpace: "nowrap",
  });

  const previewWidths = { desktop:"100%", tablet:"640px", mobile:"375px" };

  if (loading) {
    return (
      <div style={{
        minHeight: "100vh",
        background: "linear-gradient(to bottom right, #f8fafc, #e0f2fe)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: "'DM Sans', sans-serif"
      }}>
        <div style={{ textAlign: "center" }}>
          <div style={{
            width: 60,
            height: 60,
            border: "6px solid #6366f1",
            borderTopColor: "transparent",
            borderRadius: "50%",
            animation: "spin 1s linear infinite",
            margin: "0 auto 24px"
          }} />
          <p style={{ fontSize: 20, fontWeight: 700, color: "#1e293b" }}>
            Loading navigation configuration...
          </p>
          <p style={{ fontSize: 14, color: "#64748b", marginTop: 8 }}>
            Please wait a moment
          </p>
        </div>
      </div>
    );
  }

  return (
    <div style={{ fontFamily:"'DM Sans','Segoe UI',sans-serif", background:"#f8f9fb", minHeight:"100vh", display:"flex", flexDirection:"column" }}>

      <style>{`
        *, *::before, *::after { box-sizing: border-box; }
        body { margin:0; }
        .cms-desktop   { display:flex  !important; }
        .cms-mobile    { display:none  !important; }
        .cms-bottombar { display:none  !important; }
        .cms-mob-btn   { display:none  !important; }
        @media (max-width: 767px) {
          .cms-desktop   { display:none  !important; }
          .cms-mobile    { display:flex  !important; }
          .cms-bottombar { display:flex  !important; }
          .cms-mob-btn   { display:flex  !important; }
          .cms-prevmode  { display:none  !important; }
        }
        input[type=range] { cursor:pointer; }
        select { appearance:auto; }
        ::-webkit-scrollbar { width:4px; height:4px; }
        ::-webkit-scrollbar-thumb { background:#e2e8f0; border-radius:99px; }
        ::-webkit-scrollbar-track { background:transparent; }
        @keyframes spin { from { transform:rotate(0deg); } to { transform:rotate(360deg); } }
      `}</style>

      

      {/* ══════ DESKTOP LAYOUT ══════ */}
      <div className="cms-desktop" style={{ flex:1, overflow:"hidden", display:"none" }}>

        <aside style={{ width:340, background:"#fff", borderRight:"1px solid #f1f5f9", display:"flex", flexDirection:"column", overflow:"hidden", flexShrink:0 }}>
          <div style={{ padding:"12px 12px 10px", borderBottom:"1px solid #f5f5f8", display:"flex", flexWrap:"wrap", gap:5 }}>
            {tabs.map(t => (
              <button key={t.id} onClick={() => setActiveTab(t.id)} style={tabBtnStyle(activeTab===t.id)}>
                <Icon name={t.icon} size={13} color={activeTab===t.id?"#fff":"#94a3b8"} />
                {t.label}
              </button>
            ))}
          </div>
          <div style={{ flex:1, overflowY:"auto", padding:"20px 18px" }}>
            {panels[activeTab]}
          </div>
        </aside>

        <main style={{ flex:1, overflowY:"auto", background:"#f1f5f9", padding:28 }}>
          <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:16 }}>
            <Icon name="eye" size={13} color="#94a3b8" />
            <span style={{ fontSize:12, color:"#94a3b8", fontWeight:600 }}>Live Preview — {previewMode}</span>
            <div style={{ flex:1, height:1, background:"#e2e8f0" }} />
          </div>
          <div style={{ maxWidth:previewWidths[previewMode], margin:"0 auto", transition:"max-width .3s" }}>
           
            <NavigationBar cartConfig={{}} searchConfig={{}} CatConfig={{}} previewConfig={cfg} previewMode={previewMode}  />
          </div>
        </main>
      </div>

      {/* ══════ MOBILE LAYOUT ══════ */}
      <div className="cms-mobile" style={{ flex:1, flexDirection:"column", overflow:"hidden", display:"none" }}>
        {showPreview ? (
          <div style={{ flex:1, overflowY:"auto", background:"#f1f5f9", padding:14, paddingBottom:90 }}>
            <div style={{ display:"flex", alignItems:"center", gap:6, marginBottom:12 }}>
              <Icon name="eye" size={12} color="#94a3b8" />
              <span style={{ fontSize:11, color:"#94a3b8", fontWeight:700, textTransform:"uppercase", letterSpacing:"0.06em" }}>Live Preview</span>
            </div>
             <NavigationBar cartConfig={{}} searchConfig={{}} CatConfig={{}} previewConfig={cfg} previewMode="mobile"  />
          </div>
        ) : (
          <div style={{ flex:1, overflowY:"auto", padding:"16px 16px 100px" }}>
            {panels[activeTab]}
          </div>
        )}
      </div>

      {/* ══════ MOBILE BOTTOM TAB BAR ══════ */}
      <nav className="cms-bottombar" style={{ position:"fixed", bottom:0, left:0, right:0, background:"#fff", borderTop:"1.5px solid #f1f5f9", padding:"6px 4px", zIndex:200, boxShadow:"0 -2px 16px rgba(0,0,0,.07)", justifyContent:"space-around", display:"none" }}>
        {tabs.map(t => {
          const isActive = activeTab===t.id && !showPreview;
          const isSave = t.id === "save";
          return (
            <button key={t.id} onClick={() => { setActiveTab(t.id); setShowPreview(false); }} style={{ flex:1, display:"flex", flexDirection:"column", alignItems:"center", gap:3, padding:"5px 2px", border:"none", background:"none", cursor:"pointer" }}>
              <div style={{ width:38, height:28, borderRadius:9, display:"flex", alignItems:"center", justifyContent:"center", background: isSave ? (isActive?"#fef3c7":"#fffbeb") : isActive ? T.indigoBg : "transparent", transition:"background .15s" }}>
                <Icon name={t.icon} size={17} color={isSave ? "#d97706" : isActive ? T.indigo : "#94a3b8"} />
              </div>
              <span style={{ fontSize:9, fontWeight:700, letterSpacing:"0.03em", color: isSave ? "#d97706" : isActive ? T.indigo : "#94a3b8" }}>{t.label}</span>
            </button>
          );
        })}
      </nav>

    </div>
  );
}